/*
 * @Author: zhang lin
 * @Date: 2022-04-11 16:16:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-02 10:05:23
 * @Description: file content
 */
import React, { useState, useEffect } from 'react';
import styles from './index.less';
import { Form, Input, Button, Checkbox } from 'sup-ui';
import loginBg from 'root/assets/images/bg_sign.png';
import logo from 'root/assets/images/logo_yunwei.svg';
import md5 from 'js-md5';
import { useIntl } from 'react-intl';
import { login } from 'root/services/user';
import messages from './messages';

const Login = (props: any) => {
  const { getFieldDecorator } = props.form;
  const intl = useIntl();
  // 设置默认用户名
  const [defaultName, setDefaultName] = useState('');
  const [errMsg, setErrMsg] = useState('');

  // 获取记住的用户名
  useEffect(() => {
    const username = localStorage.getItem('username');

    if (username) setDefaultName(username);
  }, []);

  //  点击提交按钮处理函数
  const handleSubmit = (e: any) => {
    e.preventDefault();
    props.form.validateFields((err: any, values: any) => {
      if (!err) {
        const { username, password, remember } = values;
        // 设置记住用户名操作
        rememberUsername(remember, username);

        // 对比用户名和密码是否为指定的值，比对成功把tiket存到本地存储中，并跳转到首页
        const params = {
          account: username,
          password: md5(password),
        };
        login(params)
          .then((res) => {
            localStorage.setItem('ticket', res.data);
            localStorage.setItem('account', username);
            window.location.href = '/';
          })
          .catch((err) => {
            if (['000061', '000062', '000064'].includes(err?.data?.code)) setErrMsg(err?.data?.message);
          });
      }
    });
  };

  // 点击记住用户名
  const rememberUsername = (checked: boolean, username: string) => {
    if (checked) {
      localStorage.setItem('username', username);
      return;
    }
    localStorage.removeItem('username');
  };

  return (
    <div className={styles.loginPage}>
      <div className={styles.left}>
        <img src={loginBg} className={styles.loginBg} />
        <img src={logo} className={styles.logo} />
      </div>
      <div className={styles.right}>
        <h4 className={styles.title}>{intl.formatMessage(messages.title)}</h4>
        <Form onSubmit={handleSubmit} wrapperCol={{ span: 24 }}>
          <Form.Item>
            {getFieldDecorator('username', {
              rules: [{ required: true, message: intl.formatMessage(messages.usernameNull) }],
              initialValue: defaultName,
            })(<Input placeholder={intl.formatMessage(messages.username)} autoComplete="off" maxLength="64" />)}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: intl.formatMessage(messages.passwordNull) }],
            })(
              <Input
                type="password"
                placeholder={intl.formatMessage(messages.password)}
                autoComplete="new-password"
                maxLength="64"
              />,
            )}
          </Form.Item>
          {errMsg && <span className={styles.errMsg}>{errMsg}</span>}
          <Form.Item>
            {getFieldDecorator('remember', {
              valuePropName: 'checked',
              initialValue: false,
            })(<Checkbox />)}

            <span className={styles.formForgot}>{intl.formatMessage(messages.rememberUsername)}</span>
            <Button type="primary" htmlType="submit" className={styles.loginBtn}>
              {intl.formatMessage(messages.login)}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
export default Form.create()(Login);
